import { API_URL } from '../../../app-config/constants';
import type { EmailTemplateDto, EmailTemplatePreview } from '../../../types/EmailTemplateDto';
import { post } from '../request';

/*
    This is in its own file because it doesn't need to be invalidated by the EmailTemplates api
*/

previewDto.operation = 'READ';
export function previewDto(template: EmailTemplateDto) {
    return post<EmailTemplatePreview>(`${API_URL}/email-templates/preview`, { postData: template });
}
